export enum AlertRemediationTerminatedActionStatus {
    Unknown = 0,
    Succeed = 1,
    PartialySucceed = 2,
    Failed = 3
}